import template from "./sign-up-page.html";

const SignUpPageComponent = {
  template: template,

  controller: class SignUpPageController {
    /* @ngInject */
    constructor(
      $rootScope,
      $window,
      $scope,
      $state,
      $filter,
      $location,
      SecurityManager,
      SweetAlertService
    ) {
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.$scope = $scope;
      this.$state = $state;
      this.$filter = $filter;
      this.$location = $location;
      this.SecurityManager = SecurityManager;
      this.SweetAlertService = SweetAlertService;
    }

    $onInit() {
      if (this.SecurityManager.isAuthenticated()) this.$state.go("index");

      this.loading = false;

      const { name, surname, email } = this.$location.search();
      this.name = name;
      this.surname = surname;
      this.email = email;

      this.password = null;
      this.emailError = false;
      this.termsAndConditions = false;
      this.newsletter = false;
      this.discounts = false;
      this.showLegalError = false;

      this.$rootScope.$watch(
        () => this.termsAndConditions,
        (newVal) => (this.showLegalError = newVal !== true)
      );

      this.$scope.$watch(
        () => this.email,
        (newVal, oldVal) => {
          if (this.emailError && !angular.equals(newVal, oldVal))
            this.emailError = false;
        }
      );
    }

    async signUp() {
      this.emailError = false;
      if (!this.form.$valid) return;

      if (!this.termsAndConditions) {
        this.showLegalError = true;
        this.animateTermsAndConditions();
        return;
      }

      this.SweetAlertService.processingRequest();
      this.loading = true;

      const locale =
        this.$window.navigator.language.split("-")[0] === "es" ? "es" : "en";

      try {
        const user = await this.SecurityManager.signUp(
          this.name,
          this.surname,
          this.email,
          this.password,
          this.newsletter,
          this.discounts,
          locale
        );
        this.SecurityManager.storeCredentials(user.accessToken);
        this.$rootScope.user = user;
        this.SweetAlertService.close();
        this.$state.go("index");
      } catch (e) {
        this.SweetAlertService.close();
        this.loading = false;
        if (e.data === "Email does not pass DNS checker") {
          this.emailError = this.$filter("trans")("errors.auth.noDnsEmail");
        } else if (e.data === "Email on disposable email list") {
          this.emailError = this.$filter("trans")(
            "errors.auth.disposableEmail"
          );
        } else if (e.data === "Email is already registered") {
          this.error = this.$filter("trans")("errors.auth.registeredEmail");
        } else {
          throw e;
        }
        this.$rootScope.$applyAsync();
      }
    }

    goLogin() {
      this.$state.go("login");
    }

    animateTermsAndConditions() {
      const interval = 100;
      const distance = 10;
      const times = 6;

      for (let i = 0; i < times + 1; i++) {
        $(".terms-conditions-animate").animate(
          { left: i % 2 === 0 ? distance : distance * -1 },
          interval
        );
      }

      $(".terms-conditions-animate").animate({ left: 0, top: 0 }, interval);
    }
  },
};

export default SignUpPageComponent;
